/*
 * Digital Moments Rio
 * Global Design Type Controller
 *
 * Controls the custom order form according to the
 * Shopify/Dawn "Design Type" variant.
 */

(function () {
  'use strict';

  // Prevent the script from being initialized more than once.
  if (window.__DMRDesignTypeControllerLoaded) {
    return;
  }

  window.__DMRDesignTypeControllerLoaded = true;

  var FORM_SELECTOR = '[data-dmr-ai-form]';

  /**
   * Normalize a value for comparison.
   */
  function normalize(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  /**
   * Get the currently selected Design Type.
   *
   * IMPORTANT:
   * The current Shopify/Dawn variant picker uses:
   *
   * data-option-name="Design Type"
   *
   * The input name may be:
   *
   * name="Design Type-1"
   *
   * Therefore we intentionally do NOT depend on the name attribute.
   */
  function getDesignType() {
    var input = document.querySelector(
      'input[data-option-name="Design Type"]:checked'
    );

    if (!input) {
      input = document.querySelector(
        'input[data-option-name="design type"]:checked'
      );
    }

    if (input) {
      return input.value || input.getAttribute('value') || '';
    }

    /*
     * Fallback for select-based variant pickers.
     */
    var select = document.querySelector(
      'select[name="options[Design Type]"]'
    );

    if (!select) {
      select = document.querySelector(
        'select[data-option-name="Design Type"]'
      );
    }

    if (select) {
      return select.value || '';
    }

    /*
     * Fallback for fieldset-based implementations.
     */
    var fieldsetInput = document.querySelector(
      'fieldset[data-option-name="Design Type"] input:checked'
    );

    if (fieldsetInput) {
      return fieldsetInput.value || '';
    }

    return '';
  }

  /**
   * Convert Shopify Design Type into the internal panel name.
   */
  function getServiceFromDesignType(value) {
    var type = normalize(value);

    if (
      type === 'ai image enhancement' ||
      type.indexOf('ai image enhancement') !== -1
    ) {
      return 'image-enhancement';
    }

    if (
      type === 'custom party design' ||
      type.indexOf('custom party design') !== -1
    ) {
      return 'party-design';
    }

    if (
      type === 'custom backdrop design' ||
      type.indexOf('custom backdrop design') !== -1
    ) {
      return 'backdrop-design';
    }

    return '';
  }

  /**
   * Update one custom order form.
   */
  function updateForm(form) {
    if (!form) {
      return;
    }

    var designType = getDesignType();
    var service = getServiceFromDesignType(designType);

    var panels = form.querySelectorAll(
      '[data-dmr-ai-panel]'
    );

    panels.forEach(function (panel) {
      var panelType = panel.getAttribute(
        'data-dmr-ai-panel'
      );

      var isActive = panelType === service;

      panel.classList.toggle(
        'is-active',
        isActive
      );

      panel.hidden = !isActive;

      /*
       * Disable fields inside inactive panels.
       * This prevents hidden fields from interfering with
       * form validation or submission.
       */
      var fields = panel.querySelectorAll(
        'input, select, textarea, button'
      );

      fields.forEach(function (field) {
        if (isActive) {
          field.disabled = false;

          /*
           * Restore required state if the original form
           * marked this field as required.
           */
          if (
            field.hasAttribute('data-dmr-required') &&
            field.getAttribute('data-dmr-required') === 'true'
          ) {
            field.required = true;
          }
        } else {
          /*
           * Remember the original required state.
           */
          if (field.required) {
            field.setAttribute(
              'data-dmr-required',
              'true'
            );
          }

          field.required = false;
          field.disabled = true;
        }
      });
    });

    /*
     * Keep the selected service synchronized with
     * fields used by the existing custom form.
     */
    var serviceFields = form.querySelectorAll(
      '[data-dmr-ai-service]'
    );

    serviceFields.forEach(function (field) {
      if ('value' in field) {
        field.value = service;
      } else {
        field.setAttribute(
          'data-dmr-ai-service',
          service
        );
      }
    });

    /*
     * If Shopify hasn't selected a recognized Design Type,
     * hide all custom panels.
     */
    if (!service) {
      panels.forEach(function (panel) {
        panel.classList.remove('is-active');
        panel.hidden = true;
      });
    }
  }

  /**
   * Update every custom order form on the page.
   */
  function updateAllForms() {
    var forms = document.querySelectorAll(
      FORM_SELECTOR
    );

    forms.forEach(function (form) {
      updateForm(form);
    });
  }

  /*
   * Prevent excessive updates when Shopify changes
   * several DOM elements at once.
   */
  var updateScheduled = false;

  function scheduleUpdate() {
    if (updateScheduled) {
      return;
    }

    updateScheduled = true;

    window.requestAnimationFrame(function () {
      updateScheduled = false;
      updateAllForms();
    });
  }

  /**
   * Listen for Design Type changes.
   */
  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;

      if (!target || !target.matches) {
        return;
      }

      if (
        target.matches(
          'input[data-option-name="Design Type"]'
        ) ||
        target.matches(
          'input[data-option-name="design type"]'
        ) ||
        target.matches(
          'input[type="radio"][data-option-name]'
        ) ||
        target.matches(
          'select[name="options[Design Type]"]'
        ) ||
        target.matches(
          'select[data-option-name="Design Type"]'
        )
      ) {
        scheduleUpdate();
      }
    },
    true
  );

  /**
   * Shopify/Dawn variant events.
   */
  document.addEventListener(
    'variant:change',
    scheduleUpdate,
    true
  );

  document.addEventListener(
    'variant:changed',
    scheduleUpdate,
    true
  );

  /**
   * Shopify/Dawn can replace parts of the product
   * section after a variant change.
   *
   * MutationObserver makes sure the controller is
   * applied again after those DOM replacements.
   */
  var observer = new MutationObserver(
    function (mutations) {
      var relevant = mutations.some(
        function (mutation) {
          return (
            mutation.addedNodes &&
            mutation.addedNodes.length > 0
          );
        }
      );

      if (relevant) {
        scheduleUpdate();
      }
    }
  );

  /**
   * Start controller.
   */
  function startController() {
    if (!document.body) {
      return;
    }

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

    updateAllForms();
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      startController
    );
  } else {
    startController();
  }

})();